import { render, staticRenderFns } from "./NomenclatureArticle.vue?vue&type=template&id=66cd055a&scoped=true"
import script from "./NomenclatureArticle.vue?vue&type=script&lang=js"
export * from "./NomenclatureArticle.vue?vue&type=script&lang=js"
import style0 from "./NomenclatureArticle.vue?vue&type=style&index=0&id=66cd055a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd055a",
  null
  
)

export default component.exports